module.exports = __webpack_public_path__ + "img/club_03.75025dca.png";